module.exports = __webpack_public_path__ + "img/outlander2022_feel.47316c80.jpg";